import React, { useEffect, useState } from "react";
import {
  Button,
  Form,
  Col,
  Row,
  Tabs,
  Tab,
  ButtonToolbar,
  Modal,
} from "react-bootstrap";
import {
  Card,
  CardBody,
  CardHeader,
  CardHeaderToolbar,
  CardHeaderTitle,
} from "../../../_metronic/_partials/controls";
import { LayoutSplashScreen } from "../../../_metronic/layout";
import { useSelector, useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import { formLabelsTheme, showErrorDialog, showSuccessDialog } from "../../utility";
import BootstrapTable from "react-bootstrap-table-next";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { toAbsoluteUrl } from "../../../_metronic/_helpers";
import SVG from "react-inlinesvg";

import { makeStyles, fade, ThemeProvider } from "@material-ui/core/styles";
import TextField from "@material-ui/core/TextField";
import Input from "@material-ui/core/Input";
import OutlinedInput from "@material-ui/core/OutlinedInput";
import FilledInput from "@material-ui/core/FilledInput";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import FormHelperText from "@material-ui/core/FormHelperText";
import FormControl from "@material-ui/core/FormControl";
import Select from "react-select";
import { useDropzone } from "react-dropzone";
import {
  fetchParameter,
  fetchParameter2,
  fetchParameter3,
  fetchParameter4,
  fetchParameter5,
  selectParameter,
  selectParameter2,
  selectParameter3,
  selectParameter4,
  selectParameter5,
  selectParameter6,
} from "../businessParameter/businessParameterSlice";
import {
  editBusinessGroup,
  fecthTz,
  fetchBusinessGroup,
  resetData,
  selectBusinessGroup,
  selectLoading,
  selectTz,
} from "./businessGroupSlice";
import { NumberSequence } from "./NumberSequence";
import { Autocomplete } from "@material-ui/lab";

const useStylesReddit = makeStyles((theme) => ({
  root: {
    border: "1px solid #e2e2e1",
    overflow: "hidden",
    borderRadius: 4,
    backgroundColor: "#FFFFFF",
    transition: theme.transitions.create(["border-color", "box-shadow"]),
    "&:hover": {
      backgroundColor: "#fff",
    },
    "&$focused": {
      backgroundColor: "#fff",
      boxShadow: `${fade(theme.palette.primary.main, 0.25)} 0 0 0 2px`,
      borderColor: theme.palette.primary.main,
    },
  },
  focused: {},
}));

function RedditTextField(props) {
  const classes = useStylesReddit();

  return (
    <TextField InputProps={{ classes, disableUnderline: true }} {...props} />
  );
}

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    flexWrap: "wrap",
  },
  margin: {
    margin: theme.spacing(1),
  },
}));

export const UiConfigurationTab = ({ actiive }) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const history = useHistory();
  const loading = useSelector(selectLoading);
  const data = useSelector(selectBusinessGroup);
  const dataParam = useSelector(selectParameter);
  const dataParam2 = useSelector(selectParameter2);
  const dataParam3 = useSelector(selectParameter3);
  const dataParam4 = useSelector(selectParameter4);
  const dataParam5 = useSelector(selectParameter5);
  const dataTz = useSelector(selectTz);
  const dataCulture = useSelector(selectParameter6);

  const [culture, setCulture] = useState("");
  const [dateFormat, setDateFormat] = useState("");
  const [pagination, setPagination] = useState("");
  const [timeZone, setTimeZone] = useState("");
  const [digitGrouping, setDigitGrouping] = useState("");

  const [value, setValue] = useState(0);

  useEffect(() => {
    async function fetchMyAPI() {
      // Fetch data on first load
      await resetData();
    }
    fetchMyAPI();
  }, [dispatch]);

  useEffect(() => {
    if (data !== null) {
      setCulture(data.culture);
      setDateFormat(data.date_format);
      setPagination(data.pagination.toString());
      setTimeZone(data.time_zone);
      setDigitGrouping(data.digit_grouping);
    }
  }, [data]);

  const types = ["Display Setting", "Number Sequence"];
  const [active, setActive] = useState(types[0]);

  const getValueType = (value, options) => {
    const return_value = options.filter((val) => value === val.value);
    return return_value;
  };

  // const handleCountry = (e) => {
  //   if (e === null) {
  //     e = undefined;
  //     setCountry_id("");
  //   } else {
  //     setCountry_id(e.value);
  //   }
  // };
  const cultureOptions = dataCulture.map((e) => {
    return {
      value: e.param_code,
      label: e.param_code + " " + e.param_value,
    };
  });

  const dateOptions = dataParam5.map((e) => {
    return {
      value: e.param_value,
      label: e.param_value,
    };
  });
  const digitOptions = dataParam3.map((e) => {
    return {
      value: e.param_value,
      label: e.param_value,
    };
  });
  const paginationOptions = dataParam4.map((e) => {
    return {
      value: e.param_value,
      label: e.param_value,
    };
  });

  const tzOptions = dataTz.map((e) => {
    return {
      value: e.id,
      label: e.name,
    };
  });

  const [values, setValues] = useState({
    culture: "",
    date_format: "",
    pagination: "",
    time_zone: "",
    digit_grouping: "",
  });

  const handleChange = (name) => (event) => {
    setValues({ ...values, [name]: event.target.value });
  };

  const handleSaveSetting = async () => {
    const params = {
      culture: culture,
      date_format: dateFormat,
      pagination: pagination,
      time_zone: timeZone,
      digit_grouping: digitGrouping,
    };

    try {
      const response = await dispatch(editBusinessGroup(params));
      console.log(response, "responsse");
      if (response.payload.status === 200) {
        const action = await showSuccessDialog(response.payload.data.message);
        await dispatch(fetchBusinessGroup());
      } else {
        showErrorDialog(response.payload.data.message);
      }
    } catch (error) {
      showErrorDialog(error.message);
    }
  };

  const indexTz = tzOptions.findIndex((obj) => obj.value === timeZone);
  const indexDate = dateOptions.findIndex((obj) => obj.value === dateFormat);
  const indexCulture = cultureOptions.findIndex((obj) => obj.value === culture);
  const indexDigit = digitOptions.findIndex(
    (obj) => obj.value === digitGrouping
  );
  const indexPagin = paginationOptions.findIndex(
    (obj) => obj.value === pagination
  );

  // tab sequence
  const [fields, setFields] = useState([
    { id: "", value: "", params: "", label: "", add: "N", editor: "text" },
  ]);

  return loading ? (
    <LayoutSplashScreen />
  ) : (
    <>
      <Card>
        <CardBody>
          <ButtonToolbar>
            {types.map((type) => (
              <Button
                active={active === type}
                onClick={() => setActive(type)}
                variant="outline-primary"
                className="m-2 "
              >
                {type}
              </Button>
            ))}
          </ButtonToolbar>

          <ThemeProvider theme={formLabelsTheme}>
            <>
              {active === "Display Setting" && (
                <CardBody>
                  <div>
                    <Row>
                      <Col xs={12} sm={3} md={6} lg={6}>
                        <Autocomplete
                          disablePortal
                          options={cultureOptions}
                          getOptionLabel={(option) => option.label.toString()}
                          disableClearable={true}
                          onChange={(e, value) => setCulture(value.value)}
                          value={cultureOptions[indexCulture]}
                          renderInput={(params) => (
                            <RedditTextField
                              required
                              className={classes.margin}
                              {...params}
                              label="Culture"
                              id="reddit-input"
                              size="small"
                              fullWidth
                              placeholder="Select Culture"
                            />
                          )}
                        />
                        <Autocomplete
                          disablePortal
                          options={dateOptions}
                          getOptionLabel={(option) => option.label.toString()}
                          disableClearable={true}
                          onChange={(e, value) => setDateFormat(value.value)}
                          value={dateOptions[indexDate]}
                          renderInput={(params) => (
                            <RedditTextField
                              required
                              className={classes.margin}
                              {...params}
                              label="Date Format"
                              id="reddit-input"
                              size="small"
                              fullWidth
                              placeholder="Select Date"
                            />
                          )}
                        />
                        <Autocomplete
                          disablePortal
                          options={paginationOptions}
                          getOptionLabel={(option) => option.label.toString()}
                          disableClearable={true}
                          onChange={(e, value) => setPagination(value.value)}
                          value={paginationOptions[indexPagin]}
                          renderInput={(params) => (
                            <RedditTextField
                              required
                              className={classes.margin}
                              {...params}
                              label="Pagination"
                              id="reddit-input"
                              size="small"
                              fullWidth
                              placeholder="Select Pagination"
                            />
                          )}
                        />
                      </Col>
                      <Col xs={12} sm={3} md={6} lg={6}>
                        <Autocomplete
                          disablePortal
                          options={tzOptions}
                          getOptionLabel={(option) => option.label.toString()}
                          disableClearable={true}
                          onChange={(e, value) => setTimeZone(value.value)}
                          value={tzOptions[indexTz]}
                          renderInput={(params) => (
                            <RedditTextField
                              required
                              className={classes.margin}
                              {...params}
                              label="Time Zone"
                              id="reddit-input"
                              size="small"
                              fullWidth
                              placeholder="Select Time Zone"
                            />
                          )}
                        />
                        <Autocomplete
                          disablePortal
                          options={digitOptions}
                          getOptionLabel={(option) => option.label.toString()}
                          disableClearable={true}
                          onChange={(e, value) => setDigitGrouping(value.value)}
                          value={digitOptions[indexDigit]}
                          renderInput={(params) => (
                            <RedditTextField
                              required
                              className={classes.margin}
                              {...params}
                              label="Digit Grouping"
                              id="reddit-input"
                              size="small"
                              fullWidth
                              placeholder="Select Digit Grouping"
                            />
                          )}
                        />
                      </Col>
                    </Row>
                  </div>
                  <Row className="mt-6 justify-content-end">
                    <Button variant="primary" onClick={handleSaveSetting}>
                      Save
                    </Button>
                  </Row>
                </CardBody>
              )}
              {active === "Number Sequence" && (
                <NumberSequence
                  fields={fields}
                  setFields={setFields}
                  value={value}
                  setValue={setValue}
                  active={active}
                />
              )}
            </>
          </ThemeProvider>
        </CardBody>
      </Card>
    </>
  );
};
